import { createContext, useContext, useRef } from "react";

import { Toast } from "primereact/toast";

import {
  SnackbarContextType,
  SnackbarOptions,
  SnackbarProviderProps,
} from "interfaces";

const SnackbarContext = createContext<SnackbarContextType>(
  {} as SnackbarContextType
);
export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  return context;
};

export const SnackbarProvider: React.FC<SnackbarProviderProps> = ({
  children,
}) => {
  const toastRef = useRef<any>(null);

  const showSnackbar = ({
    severity,
    summary,
    detail,
    life = 5000,
    sticky = false,
  }: SnackbarOptions) => {
    toastRef.current.clear();
    const message = {
      severity: severity,
      summary: summary,
      detail: detail,
      sticky: sticky,
      closable: true,
      life: life,
    };
    toastRef.current.show([message]);
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      <>
        <Toast position="bottom-left" ref={toastRef} />
        {children}
      </>
    </SnackbarContext.Provider>
  );
};
